import React, { useState, useEffect } from 'react'
import { supabase } from '../../supabaseClient'
import { Modal, Button, ListGroup, Form, Alert, Spinner } from 'react-bootstrap'
import ConfirmationPopup from './ConfirmationPopup'
import '../../assets/css/checklist.css'
function DeleteCategory ({ show, categpries, handleClose, type, onCategoryDeleted }) {
  const [confirmShow, setConfirmShow] = useState(false)
  const [categoryId, setCategoryId] = useState(null)
  const [subCategories, setSubCategories] = useState([])
  const [localCategories, setLocalCategories] = useState([])
  const [isDeleting, setIsDeleting] = useState(false)

  // Sync local categories with prop when modal opens or prop changes
  useEffect(() => {
    if (categpries) {
      setLocalCategories(categpries)
    }
  }, [categpries])
  useEffect(() => {
    const fetchSubCategoriesTask = async () => {
      try {
        const { data, error } = await supabase
          .from('categories')
          .select('id, name,parent_category_id')
          .not('parent_category_id', 'is', null)

        if (error) {
          console.error('Error fetching subcategories:', error)
        } else {
          const formattedData = data.map(item => ({
            id: item.id,
            name: item.name,
            parent_category_id: item.parent_category_id
          }))
          setSubCategories(formattedData)
        }
      } catch (err) {
        console.error('Unexpected error:', err)
      }
    }

    const fetchSubCategoriesNote = async () => {
      try {
        const { data, error } = await supabase
          .from('notes_categories')
          .select('id, name,parent_category_id')
          .not('parent_category_id', 'is', null)

        if (error) {
          console.error('Error fetching subcategories:', error)
        } else {
          const formattedData = data.map(item => ({
            id: item.id,
            name: item.name,
            parent_category_id: item.parent_category_id
          }))
          setSubCategories(formattedData)
        }
      } catch (err) {
        console.error('Unexpected error:', err)
      }
    }

    const fetchSubCategoriesList = async () => {
      try {
        const { data, error } = await supabase
          .from('lists_categories')
          .select('id, name,parent_category_id')
          .not('parent_category_id', 'is', null)

        if (error) {
          console.error('Error fetching subcategories:', error)
        } else {
          const formattedData = data.map(item => ({
            id: item.id,
            name: item.name,
            parent_category_id: item.parent_category_id
          }))
          setSubCategories(formattedData)
        }
      } catch (err) {
        console.error('Unexpected error:', err)
      }
    }
    
    const fetchSubCategoriesGroceries = async () => {
      try {
        const { data, error } = await supabase
          .from('grocery_categories')
          .select('id, name,parent_category_id')
          .not('parent_category_id', 'is', null)

        if (error) {
          console.error('Error fetching subcategories:', error)
        } else {
          const formattedData = data.map(item => ({
            id: item.id,
            name: item.name,
            parent_category_id: item.parent_category_id
          }))
          setSubCategories(formattedData)
        }
      } catch (err) {
        console.error('Unexpected error:', err)
      }
    }
    
    if (type === 'tasks') {
      fetchSubCategoriesTask()
    } else if (type === 'notes') {
      fetchSubCategoriesNote()
    } else if (type === 'lists') {
      fetchSubCategoriesList()
    } else if (type === 'groceries') {
      fetchSubCategoriesGroceries()
    }
  }, [categpries, type])
  let handleCategoryDelete = async categoryId => {
    setIsDeleting(true)
    let deleteSuccess = false

    try {
      if (type === 'tasks') {
        const { data: tasksData, error: tasksError } = await supabase
          .from('tasks')
          .update({ category_id: 0 })
          .eq('category_id', categoryId)

        if (tasksError) {
          console.error('Error deleting tasks:', tasksError)
        }
        // Delete all subcategories first
        const { data: subCategoryData, error: subCategoryError } = await supabase
          .from('categories')
          .delete()
          .eq('parent_category_id', categoryId)

        if (subCategoryError) {
          console.error('Error deleting subcategories:', subCategoryError)
        } else {
          // Delete the main category
          const { data, error } = await supabase
            .from('categories')
            .delete()
            .eq('id', categoryId)

          if (error) {
            console.error('Error deleting category:', error)
          } else {
            deleteSuccess = true
          }
        }
      } else if (type === 'notes') {
        const { data: notesData, error: notesError } = await supabase
          .from('notes')
          .update({ category_id: 0 })
          .eq('category_id', categoryId)

        if (notesError) {
          console.error('Error deleting notes:', notesError)
        }

        const { data: subCategoryData, error: subCategoryError } = await supabase
          .from('notes_categories')
          .delete()
          .eq('parent_category_id', categoryId)
        if (!subCategoryError) {
          const { data, error } = await supabase
            .from('notes_categories')
            .delete()
            .eq('id', categoryId)

          if (error) {
            console.error('Error deleting category:', error)
          } else {
            deleteSuccess = true
          }
        } else {
          console.error('Error deleting subcategories:', subCategoryError)
        }
      } else if (type === 'lists') {
        const { data: listsData, error: listsError } = await supabase
          .from('lists')
          .update({ category_id: 0 })
          .eq('category_id', categoryId)
        if (listsError) {
          console.error('Error deleting tasks:', listsData)
        }
        const { data: subCategoryData, error: subCategoryError } = await supabase
          .from('lists_categories')
          .delete()
          .eq('parent_category_id', categoryId)

        if (!subCategoryError) {
          const { data, error } = await supabase
            .from('lists_categories')
            .delete()
            .eq('id', categoryId)

          if (error) {
            console.error('Error deleting category:', error)
          } else {
            deleteSuccess = true
          }
        }
      } else if (type === 'groceries') {
        // Update grocery items to remove category reference
        const { error: groceriesError } = await supabase
          .from('grocery_table')
          .update({ grocery_table_id: null })
          .eq('grocery_table_id', categoryId)

        if (groceriesError) {
          console.error('Error updating grocery items:', groceriesError)
        }
        
        // Delete all subcategories first
        const { error: subCategoryError } = await supabase
          .from('grocery_categories')
          .delete()
          .eq('parent_category_id', categoryId)

        if (!subCategoryError) {
          // Delete the main category
          const { error } = await supabase
            .from('grocery_categories')
            .delete()
            .eq('id', categoryId)

          if (error) {
            console.error('Error deleting category:', error)
          } else {
            deleteSuccess = true
          }
        } else {
          console.error('Error deleting subcategories:', subCategoryError)
        }
      }

      if (deleteSuccess) {
        // Update local categories state to remove the deleted category
        setLocalCategories(prev => prev.filter(category => category.id !== categoryId))
        // Update subcategories state to remove any subcategories of the deleted category
        setSubCategories(prev => prev.filter(subCat => subCat.parent_category_id !== categoryId && subCat.id !== categoryId))
        // Notify parent to refresh categories
        if (onCategoryDeleted) {
          onCategoryDeleted()
        }
      }
    } catch (err) {
      console.error('Unexpected error during deletion:', err)
    } finally {
      setIsDeleting(false)
      setConfirmShow(false)
    }
  }
  return (
    <>
      <Modal show={show} onHide={isDeleting ? undefined : handleClose} animation={false} centered backdrop={isDeleting ? 'static' : true} className='task-popup'>
        <Modal.Header closeButton={!isDeleting}>
          <Modal.Title>Delete Categories</Modal.Title>
          {isDeleting && (
            <div className='d-flex align-items-center ms-3'>
              <Spinner animation='border' size='sm' role='status' variant='dark'>
                <span className='visually-hidden'>Deleting...</span>
              </Spinner>
              <span className='ms-2' style={{ fontSize: '14px' }}>Deleting...</span>
            </div>
          )}
        </Modal.Header>
        <div className='accordion' id='categoriesAccordion'>
          {localCategories.length === 0 && (
            <div className='p-4 text-center text-muted'>
              No categories available to delete.
            </div>
          )}
          {localCategories.map((category, index) => {
            const filteredSubCategories = subCategories.filter(
              subCategory => subCategory.parent_category_id === category.id
            )

            const hasSubCategories = filteredSubCategories.length > 0

            return hasSubCategories ? (
              <div className='accordion-item' key={index}>
                <h2
                  className='accordion-header d-flex align-items-center justify-content-between'
                  id={`heading-${category.id}`}
                >
                  <button
                    className='accordion-button collapsed flex-grow-1 text-start'
                    type='button'
                    data-bs-toggle='collapse'
                    data-bs-target={`#collapse-${category.id}`}
                    aria-expanded='false'
                    aria-controls={`collapse-${category.id}`}
                  >
                    {category.name}
                  </button>
                  <Button
                    variant='dark'
                    size='sm'
                    className='mx-3'
                    disabled={isDeleting}
                    onClick={e => {
                      e.stopPropagation()
                      setCategoryId(category.id)
                      setConfirmShow(true)
                    }}
                  >
                    <i className='bi bi-trash'></i>
                  </Button>
                </h2>
                <div
                  id={`collapse-${category.id}`}
                  className='accordion-collapse collapse'
                  aria-labelledby={`heading-${category.id}`}
                  data-bs-parent='#categoriesAccordion'
                >
                  <div className='accordion-body'>
                    <ul className='mb-0'>
                      {filteredSubCategories.map(subCategory => (
                        <li
                          className='mb-3 d-flex justify-content-between align-items-center'
                          key={subCategory.id}
                        >
                          {subCategory.name}
                          <Button
                            variant='dark'
                            size='sm'
                            className='ms-2'
                            disabled={isDeleting}
                            onClick={e => {
                              e.stopPropagation()
                              setCategoryId(subCategory.id)
                              setConfirmShow(true)
                            }}
                          >
                            <i className='bi bi-trash'></i>
                          </Button>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ) : (
              <div className='accordion-item' key={index}>
              <h2
                className='accordion-header d-flex align-items-center justify-content-between'
                id={`heading-${category.id}`}
              >
                <button
                  className='accordion-button-hide collapsed flex-grow-1 text-start'
                  type='button'
                >
                  {category.name}
                </button>
                <Button
                  variant='dark'
                  size='sm'
                  className='mx-3'
                  disabled={isDeleting}
                  onClick={e => {
                    e.stopPropagation()
                    setCategoryId(category.id)
                    setConfirmShow(true)
                  }}
                >
                  <i className='bi bi-trash'></i>
                </Button>
              </h2>
              </div>
              // <div
              //   className='d-flex align-items-center justify-content-between mb-3'
              //   key={index}
              // >
              //   <span>{category.name}</span>
              //   <Button
              //     variant='dark'
              //     size='sm'
              //     onClick={e => {
              //       e.stopPropagation()
              //       setCategoryId(category.id)
              //       setConfirmShow(true)
              //     }}
              //   >
              //     <i className='bi bi-trash'></i>
              //   </Button>
              // </div>
            )
          })}
        </div>

        <Modal.Footer>
          <Button variant='secondary' onClick={handleClose} disabled={isDeleting}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <ConfirmationPopup
        show={confirmShow}
        handleClose={() => setConfirmShow(false)}
        title='Delete Category'
        body='Are you sure you want to delete this category? It will delete all the related records as well.'
        handleConfirm={() => {
          handleCategoryDelete(categoryId)
        }}
        message='This action cannot be undone.'
      />
    </>
  )
}
export default DeleteCategory
